import { useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { PageHero, SectionHeading, Reveal } from "../components/common";
import { DestinationCard } from "../components/cards";
import { Input } from "../components/ui/input";
import { DESTINATIONS } from "../mock";

export default function Destinations() {
  const [q, setQ] = useState("");
  const list = DESTINATIONS.filter((d) =>
    d.name.toLowerCase().includes(q.toLowerCase()) || d.city.toLowerCase().includes(q.toLowerCase())
  );

  return (
    <>
      <PageHero
        eyebrow="Explore Opportunities"
        title="Choose your study destination"
        subtitle="A wide range of countries, each offering unique academic experiences, career pathways and cultural exposure."
        image="https://images.unsplash.com/photo-1485871981521-5b1fd3805eee"
      />
      <section className="section-pad bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-md mx-auto relative -mt-2 mb-14">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search a country or city..."
              className="pl-11 h-13 py-6 rounded-full border-slate-200 focus-visible:ring-[#004030]"
            />
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {list.map((d, i) => (
              <Reveal key={d.slug} delay={i * 60}><DestinationCard d={d} /></Reveal>
            ))}
          </div>
          {list.length === 0 && (
            <p className="text-center text-slate-400 py-16">No destinations match your search.</p>
          )}
        </div>
      </section>
    </>
  );
}